<template>
  <div class="charts-page">
    <div class="screen-select">
      <div :class="['select-item', activeIndex === index ? 'active' : '']" v-for="(item, index) in selectList"
        :key="index" @click="handleItemClick(index)">{{ item.label }}
      </div>
    </div>
    <div class="charts" ref="chart" />
  </div>
</template>

<script>
import echarts from "echarts";
import api from '../api'

export default {
  name: "AlarmLevelStatistics",
  data() {
    return {
      selectList: [{
        label: '近7天',
        value: '1'
      }, {
        label: '近30天',
        value: '2'
      }, {
        label: '近12月',
        value: '3'
      }],
      activeIndex: 0,
      statType: '1',
      chart: null
    }
  },
  mounted() {
    this.queryInfo()
  },
  methods: {
    handleItemClick(index) {
      this.statType = this.selectList[index].value
      this.activeIndex = index
      this.queryInfo()
    },
    async queryInfo() {
      const { success, returnObj } = await this.$fetch(api.security.statAlarmByAlarmLevel, {
        processType: "1",
        statType: this.statType
      })
      if (success) {
        const arr = returnObj ? returnObj : []
        if (arr.length > 0) {
          const chartData = []
          const xData = []
          Object.keys(arr[0].dataMap).forEach(key => {
            chartData.push({
              label: key,
              xData: [],
              yData: []
            })
          })
          arr.forEach(item => {
            xData.push(item.statDate)
            Object.keys(item.dataMap).forEach(key => {
              chartData.forEach(v => {
                v.xData = xData
                if (v.label === key) {
                  v.yData.push(item.dataMap[key])
                }
              })
            })
          })
          this.initCharts(chartData)
        }
      }
    },
    initCharts(chartData) {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
      const colorList = ["#E80505", "#FF7824", "#FBD828", "#3E82FF"];
      const seriesData = chartData.map((v, index) => {
        return {
          name: v.label,
          type: "line",
          symbolSize: 1,
          symbol: "circle",
          smooth: true,
          lineStyle: {
            width: 2,
            color: colorList[index]
          },
          data: v.yData,
        }
      })
      this.chart = echarts.init(this.$refs.chart);
      const option = {
        color: colorList,
        grid: {
          bottom: 10,
          containLabel: true,
          left: 25,
          right: 10,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: 10,
          left: 10,
          data: chartData.map(v => v.label),
          textStyle: {
            // color: "#91abd9",
            color: "#ffffff",
          },
          icon: 'rect',
          itemWidth: 12,
          itemHeight: 6,
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              // color: "rgba(255,255,255,0.7)",
              color: "#ffffff",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(230,247,255,0.2)",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(230,247,255,0.2)",
                type: "dashed",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        xAxis: [
          {
            data: chartData[0].xData,
            type: "category",
            axisTick: {
              show: false,
            },
            axisLabel: {
              // color: "rgba(255,255,255,0.7)",
              color: "#ffffff",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#1B7EF2",
              }
            }
          }
        ],
        series: seriesData
      }
      this.chart.setOption(option);
    }
  }
}
</script>

<style lang="scss" scoped>
.screen-select {
  display: flex;
  position: absolute;
  right: 0px;
  top: -48px;
  z-index: 999;

  .select-item {
    width: 60px;
    height: 24px;
    background: #000119;
    border: 1px solid #3F4163;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    font-size: 12px;

    &.active {
      background: #15A0F6;
      color: #FFFFFF;
    }
  }
}

.charts-page {
  width: 100%;
  height: 100%;
  position: relative;

  .charts {
    width: 100%;
    height: 100%;
  }
}
</style>
